import { jwtDecode } from "jwt-decode";
import en from '../../src/nls/en.json';
import moment from 'moment-timezone';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const STAGE = process.env.REACT_APP_STAGE;

export const APIS = {
  GET_USER_INFO: `${BASE_URL}/${STAGE}/user/viewUser`,
  POST_STUDENT_INFO: `${BASE_URL}/${STAGE}/user/updateuser`,
  PUT_STUDENT_INFO: `${BASE_URL}/${STAGE}/user/updateUser`,
  POST_SCHOOL_ADMIN: `${BASE_URL}/${STAGE}/user/updateSchoolAdmin/`,
  PUT_CHANGE_PASSWORD: `${BASE_URL}/${STAGE}/user/changePassword`,
  GET_USER_QUESTIONS: `${BASE_URL}/${STAGE}/questions/getQuestionSet`,
  GET_USERS_SAVED_ANSWERS_MAPPING: `${BASE_URL}/${STAGE}/questions/getResponses`,
  GET_STUDENT_PROFILE_INFO: `${BASE_URL}/${STAGE}/questions/getUserProfileForAdmin`,
  GET_MENTOR_MATERIAL: `${BASE_URL}/${STAGE}/user/getMentorMaterial`,
  POST_STUDENT_QUESTIONS_ANSWER: `${BASE_URL}/${STAGE}/questions/addResponses`,
  GET_SCHOOL_LIST: `${BASE_URL}/${STAGE}/master/schoolsList`,
  GET_HIGH_SCHOOL_LIST: `${BASE_URL}/${STAGE}/master/schoolsList?page=`,
  GET_STUDENT_LIST: `${BASE_URL}/${STAGE}/user/studentList?page=`,
  GET_STUDENT_LIST_FOR_MENTOR: `${BASE_URL}/${STAGE}/user/getMentorStudentList?page=`,
  GET_MENTOR_LIST: `${BASE_URL}/${STAGE}/user/getMentorsList?page=`,
  GET_MENTOR_LIST_ADMIN: `${BASE_URL}/${STAGE}/user/mentorList?page=`,
  GET_SCHOOL_ADMIN_ROLE: `${BASE_URL}/${STAGE}/master/getAdminRoles`,
  GET_DISTRICTS: `${BASE_URL}/${STAGE}/master/getDistricts`,
  CHECK_SURVEY: `${BASE_URL}/${STAGE}/user/isSurveyCompleted`,
  SET_SURVEY: `${BASE_URL}/${STAGE}/user/setSurveyCompleted`,
  CREATE_STUDENT: `${BASE_URL}/${STAGE}/user/addPortalUser`,
  GET_LANGUAGES: `${BASE_URL}/${STAGE}/master/getLanguages?page=`,
  GET_PREFARANCES_OPTIONS: `${BASE_URL}/${STAGE}/questions/getQuestionsPreferences`,
  POST_PREFARANCES: `${BASE_URL}/${STAGE}/questions/addUserPreferences`,
  IS_USER_EXISTS: `${BASE_URL}/${STAGE}/user/checkUser`,
  CREATE_USER: `${BASE_URL}/${STAGE}/user/`,
  GET_MENTOR_INFO: `${BASE_URL}/${STAGE}/user/viewMentor/`,
  MATCHED_MENTORS: `${BASE_URL}/${STAGE}/questions/getMatchMentors`,
  MATCHED_NEW_MENTORS: `${BASE_URL}/${STAGE}/questions/getNewMatchMentors`,
  MENTOR_BIO_DETAILS: `${BASE_URL}/${STAGE}/user/mentorBioDetails/`,
  UPDATE_MENTOR_BIO_DETAILS: `${BASE_URL}/${STAGE}/user/mentorBioDetails/`,
  UPDATE_MENTOR: `${BASE_URL}/${STAGE}/user/updateMentor/`,
  UPDATE_MENTOR_STATUS: `${BASE_URL}/${STAGE}/user/requestAction`,
  UPDATE_MENTOR_STATUS_ACTION: `${BASE_URL}/${STAGE}/user/updateMentorStatus`,
  UPDATE_MENTOR_BACKGROUND_STATUS: `${BASE_URL}/${STAGE}/user/updateMentorBackgroundCheck`,
  UPDATE_STEPPER: `${BASE_URL}/${STAGE}/master/updateSteppers`,
  POST_STUDENT_DOCUMENT: `${BASE_URL}/${STAGE}/documents/submitDocument`,
  SAVE_STUDENT_DOCUMENT: `${BASE_URL}/${STAGE}/documents/submitDocumentDraft`,
  PUT_STUDENT_DOCUMENT: `${BASE_URL}/${STAGE}/documents/updateDocument`,
  GET_DOCUMENT_LIST: `${BASE_URL}/${STAGE}/documents/getDocumentList?page=`,
  UPLOAD_PROFILE: `${BASE_URL}/${STAGE}/user/uploadProfile`,
  MENTOR_UPLOAD_PROFILE: `${BASE_URL}/${STAGE}/user/mentor-profile-upload`,
  GET_DOCUMENT_DETAILS: `${BASE_URL}/${STAGE}/documents/documentDetails/`,
  GET_DOC_TYPE: `${BASE_URL}/${STAGE}/master/getDocType?page=`,
  GET_DUE_DATE: `${BASE_URL}/${STAGE}/master/getDueDate?page=`,
  GET_PREFARANCES: `${BASE_URL}/${STAGE}/questions/getUserPreferences`,
  GET_UNIVERSITY_LIST: `${BASE_URL}/${STAGE}/master/getUniversityList?page=`,
  GET_ALL_MENTOR_LIST: `${BASE_URL}/${STAGE}/user/getMentorsList`,
  SEARCH_MENTOR: `${BASE_URL}/${STAGE}/user/getMentorsList?search=`,
  GET_FILTER_LIST: `${BASE_URL}/${STAGE}/questions/getFilters`,
  ADD_OR_REMOVE_MY_MENTOR: `${BASE_URL}/${STAGE}/user/addOrRemoveMentor`,
  FILTER_MENTOR_LIST: `${BASE_URL}/${STAGE}/user/getMentorsList`,
  SCHEDULE_MEETING: `${BASE_URL}/${STAGE}/calendar/scheduleMeeting`,
  GET_SCHEDULED_MEETINGS: `${BASE_URL}/${STAGE}/calendar/getMeetings`,
  SCHEDULED_MEETING_MESSAGE: `${BASE_URL}/${STAGE}/calendar/meetingMessage`,
  CHECK_MEETING_CREDITS: `${BASE_URL}/${STAGE}/calendar/checkMeetingCredits`,
  GET_ALL_MASSAGES: `${BASE_URL}/${STAGE}/messages/getAllUserMessages`,
  POST_SEND_MESSAGE: `${BASE_URL}/${STAGE}/messages/sendMessages`,
  GET_USER_MESSAGE: `${BASE_URL}/${STAGE}/messages/getUserMessages`,
  CANCEL_MEETING: `${BASE_URL}/${STAGE}/calendar/cancelMeeting`,
  GET_DASHBOARD_UPNEXT_DATA: `${BASE_URL}/${STAGE}/master/getDashboard`,
  RESCHEDULE_MEETING: `${BASE_URL}/${STAGE}/calendar/rescheduleMeeting`,
  GETS_LOTS: `${BASE_URL}/${STAGE}/calendar/getSlots`,
  MEETING_FEEDBACK: `${BASE_URL}/${STAGE}/feedback/submitFeedback`,
  POST_RETAKE_QUIZ: `${BASE_URL}/${STAGE}/user/requestQuiz/`,
  GET_REQUEST_TYPE: `${BASE_URL}/${STAGE}/master/getRequestType?page=1`,
  GET_SESSIONS: `${BASE_URL}/${STAGE}/stripe/getSessions`,
  GET_PLANS: `${BASE_URL}/${STAGE}/master/getPlans`,
  GET_SESSION_ID: `${BASE_URL}/${STAGE}/stripe/getSessionsByPriceId`,
  GET_USER_SUBSCRIPTION: `${BASE_URL}/${STAGE}/stripe/get_user_subscription`,
  DOWNGRADE_TO_FREE_SUBSCRIPTION: `${BASE_URL}/${STAGE}/stripe/downgradeToFreeSubscription`,
  FINISH_STRIPE: `${BASE_URL}/${STAGE}/stripe/payoutStatus`,
  FEEDBACK_REPORT: `${BASE_URL}/${STAGE}/feedback/reportUser`,
  PUT_RETAKE_QUIZ_FLAG: `${BASE_URL}/${STAGE}/user/setRetakeQuizFlag`,
  USER_CHECK_CREDIT: `${BASE_URL}/${STAGE}/user/checkCredits`,
  USER_REQUIRE_CREDIT: `${BASE_URL}/${STAGE}/user/requireCredits`,
  PROFILE_EDIT: `${BASE_URL}/${STAGE}/questions/editProfile`,
  USER_GET_CREDIT: `${BASE_URL}/${STAGE}/user/getCredits`,
  TRANSCRIPT_FILE: `${BASE_URL}/${STAGE}/user/uploadTranscript`,
  UPDATE_PLAN: `${BASE_URL}/${STAGE}/stripe/subscribe_new_plan`,
  MENTOR_PAYOUT: `${BASE_URL}/${STAGE}/stripe/connect-stripe`,
  CHECK_PAYOUTS_ENABLED: `${BASE_URL}/${STAGE}/stripe/checkPayoutsEnabled`,
  GET_ALL_GRADES: `${BASE_URL}/${STAGE}/master/getAllGrades?page=`,
  HELP_SUPPORT_DATA: `${BASE_URL}/${STAGE}/master/getHelpAndSupport`,
  HELP_SUPPORT_ADMIN_DATA: `${BASE_URL}/${STAGE}/master/getHelpAndSupportAdmin`,
  POST_COMMENTS: `${BASE_URL}/${STAGE}/master/addSupportComment`,
  DOC_EDIT_REJECTION: `${BASE_URL}/${STAGE}/documents/rejectDocument`,
  GET_ALL_STATUSES: `${BASE_URL}/${STAGE}/master/getStatuses`,
  GET_MEETING_COMMENT: `${BASE_URL}/${STAGE}/feedback/getMeetingFeedback?meeting_id=`,
  APPROVE_DENY_DOC: `${BASE_URL}/${STAGE}/documents/documentAction`,
  GET_FLAG_DETAIL: `${BASE_URL}/${STAGE}/feedback/getMeetingFlags`,
  POST_ADD_CHECKLIST_TASK: `${BASE_URL}/${STAGE}/checklists/addChecklistTask`,
  GET_DEFAULT_CHECKLIST: `${BASE_URL}/${STAGE}/checklists/getDefaultCheckListTasks`,
  GET_ALL_CHECKLIST: `${BASE_URL}/${STAGE}/checklists/getAllChecklists`,
  PUT_UPDATE_CHECKLIST: `${BASE_URL}/${STAGE}/checklists/updateChecklistTask`,
  GET_MENTORS_PAYOUT: `${BASE_URL}/${STAGE}/payout/getMentorsPayout`,
  REMOVE_SERVICES: `${BASE_URL}/${STAGE}/payout/deleteServices`,
  GET_RECENT_COUNT: `${BASE_URL}/${STAGE}/user/getRecentActivity`,
  PAY_TO_MENTOR_IN_BULK: `${BASE_URL}/${STAGE}/payout/payToMentorInBulk`,
  PAY_TO_MENTOR_BY_SERVICES: `${BASE_URL}/${STAGE}/payout/payToMentorByServices`,
  UPLOAD_STUDENT_CSV: `${BASE_URL}/${STAGE}/user/uploadUsers`,
  UPLOAD_MENTOR_CSV: `${BASE_URL}/${STAGE}/user/uploadMentors`,
  UPLOAD_ADMINISTRATOR_CSV: `${BASE_URL}/${STAGE}/user/uploadSchoolAdmins`,
  POST_ADD_PREMADE_CHECKLIST_TASK: `${BASE_URL}/${STAGE}/checklists/addPremedChecklistToStudent`,
  GET_PREMADE_CHECKLIST: `${BASE_URL}/${STAGE}/checklists/getPremedChecklists`,
  MENTOR_EARNINGS: `${BASE_URL}/${STAGE}/payout/mentorMyEarnings`,
  REMOVE_FLAG: `${BASE_URL}/${STAGE}/feedback/removeFlag/`,
  GET_CREDIT_REQUESTS: `${BASE_URL}/${STAGE}/user/getCreditRequests/`,
  GET_CREDIT_REQUESTS_DETAILS: `${BASE_URL}/${STAGE}/user/getCreditRequestDetails/`,
  POST_CREDIT_REQUEST: `${BASE_URL}/${STAGE}/user/requestAction`,
  MARK_READ_MESSAGE: `${BASE_URL}/${STAGE}/messages/readUserMessages`,
  GET_CHAT_USERS: `${BASE_URL}/${STAGE}//messages/getChatUsers`,
  GET_ALL_ADMINISTRATORSLIST: `${BASE_URL}/${STAGE}/user/getSchoolAdminList?page=`,
  PUT_CREDITS: `${BASE_URL}/${STAGE}/user/addOrRemoveCredits/`,
  REFRESH_TOKEN: `${BASE_URL}/${STAGE}/calendar/generateRefreshToken`,
  GET_CAL_INFO: `${BASE_URL}/${STAGE}/calendar/getCalInformation`,
  SCHOOL_ADMIN_RECENT_ACTIVITY: `${BASE_URL}/${STAGE}/user/getSchoolAdminActivity`,
  PUT_STUDENT_CREDITS: `${BASE_URL}/${STAGE}/user/addOrRemoveStudentCredit`,
  GET_B2C_FLOW: `${BASE_URL}/${STAGE}/user/getFlow`,
  SET_B2C_FLOW: `${BASE_URL}/${STAGE}/user/addOrUpdateFlow`,
  RESEND_TEMP_PASS: `${BASE_URL}/${STAGE}/user/resendTemporaryPassword`,
  FORGOT_PASSWORD: `${BASE_URL}/${STAGE}/user/forgotPassword`, //FP
  RESET_PASSWORD: `${BASE_URL}/${STAGE}/user/resetPassword`, //FP
  GET_EMAIL_FORGOT: `${BASE_URL}/${STAGE}/user/forgotPassword/`,
  GET_NOTIFICATION: `${BASE_URL}/${STAGE}/user/getUserNotifications`,
  READ_NOTIFICATION: `${BASE_URL}/${STAGE}/user/readNotifications`,
  DOC_EDIT_AVAILABILITY: `${BASE_URL}/${STAGE}/user/setMentorDocEditAvailability`,
  NOTIFICATION_COUNT: `${BASE_URL}/${STAGE}/user/notificationCount`,
  PUT_CONSIGNMENT: `${BASE_URL}/${STAGE}/user/updateUserConsignment`,
  MENTOR_REQUEST_ACTION: `${BASE_URL}/${STAGE}/user/requestAction`,
  AVERAGE_MENTOR_RATING: `${BASE_URL}/${STAGE}/feedback/averageMentorRating`, 
  GET_CONSIGNMENT: `${BASE_URL}/${STAGE}/user/getUserConsignment`,
  CHECK_USERS_FEEDBACK: `${BASE_URL}/${STAGE}/feedback/checkUsersFeedback`,
  CREATE_CAL_USER: `${BASE_URL}/${STAGE}/calendar/createCalUser`,
  CUSTOM_PASS_CHECK: `${BASE_URL}/${STAGE}/user/getUserRegistrationStatus?email=`,
  SET_REGISTERATION_STATUS: `${BASE_URL}/${STAGE}/user/setRegistrationStatus`,
  AI_CHAT_BOT: `${BASE_URL}/${STAGE}/chatbot/completion`,
  OTHER_SCHOOL:`${BASE_URL}/${STAGE}/master/schoolsList?is_other=true`,
  UPDATE_BOOKING_BUFFER:`https://api.cal.com/v2/event-types/`,
  GET_ALL_MEETINGS: `${BASE_URL}/${STAGE}/user/superAdminMeetings`,
  GET_STUDENT_PROFILE_NOTE: `${BASE_URL}/${STAGE}/user/adminNote`,
  ADD_NOTE_TO_STUD_PROFILE: `${BASE_URL}/${STAGE}/user/addAdminNote`,
  DELETE_NOTE_FROM_STUD_PROFILE: `${BASE_URL}/${STAGE}/user/adminNote`,
  VALIDATE_MENTOR_AVAILABILITY: `${BASE_URL}/${STAGE}/user/validateMentor`,
  SUPERADMIN_REASSIGN_INREVIEW_DOC: `${BASE_URL}/${STAGE}/user/reassignMentor`,
  GET_PORTFOLIO_DATA:`${BASE_URL}/${STAGE}/user/getStudentPortfolio`,
  ADD_PORTFOLIO_DATA:`${BASE_URL}/${STAGE}/user/addToStudentPortfolio`,
  DELETE_FROM_STUD_PORTFOLIO: `${BASE_URL}/${STAGE}/user/deleteStudentPortfolio`,
  CHECK_ADD_RESULT_POPUP:`${BASE_URL}/${STAGE}/user/checkUserLoginAttempt`,
  GET_STUDENT_RESULT_LIST:`${BASE_URL}/${STAGE}/user/getStudentResults`,
  ADD_STUDENT_RESULT:`${BASE_URL}/${STAGE}/user/addStudentResult`,
  CHECK_CLG_RESULT_EXIST:`${BASE_URL}/${STAGE}/user/checkSchoolResultExists`,
  EDIT_STUDENT_RESULT:`${BASE_URL}/${STAGE}/user/updateStudentResult`,
  SET_AS_FAV_CLG:`${BASE_URL}/${STAGE}/user/setFavouriteSchool`,
  GET_RESULT_TYPES:`${BASE_URL}/${STAGE}/master/getStudentResultTypes`,
  GET_MEETING_STATUS_SA:`${BASE_URL}/${STAGE}/calendly/getMeetingStatusTypes`,
  UPDATE_MEETING_STATUS_SA:`${BASE_URL}/${STAGE}/calendly/updateMeetingStatus`,
  JOIN_MEETING_CLICKED:`${BASE_URL}/${STAGE}/calendly/joinMeeting`,
  REPORT_MISSED_MEETING:`${BASE_URL}/${STAGE}/calendly/missedMeetingReport`,
  OPENAI_COMPLETIONS: `${BASE_URL}/${STAGE}/colly/openai/chat/completions`,
  PERPLEXITY_COMPLETIONS: `${BASE_URL}/${STAGE}/colly/perplexity/chat/completions`,
  STUDY_NOW_COURSE: `${BASE_URL}/${STAGE}/testPrep/courseURL`,
  REMOVE_COURSE: `${BASE_URL}/${STAGE}/testPrep/removeCourse`,
  ADD_COURSE: `${BASE_URL}/${STAGE}/testPrep/course`,
  GET_ALL_COURSE_LIST: `${BASE_URL}/${STAGE}/testPrep/courseList`,
  GET_MY_COURSE_LIST: `${BASE_URL}/${STAGE}/testPrep/getmyCourses`,
  B2B_REQUEST_COURSE: `${BASE_URL}/${STAGE}/testPrep/testPrepRequest`,
  GET_TEST_PREP_SUBSCRIPTION: `${BASE_URL}/${STAGE}/testPrep/getTestPrepSubscriptionsDetails`,
  CANCEL_TEST_PREP_SUBSCRIPTION: `${BASE_URL}/${STAGE}/stripe/cancelTestPrep`,
  GET_PACKAGE_SESSIONS: `${BASE_URL}/${STAGE}/stripe/getPackageSessionId`,
};

// b2c old flow
export const plansLookupRedirectUrls = {
  success: `?success_url=${window.location.origin}/user/dashboard?planSelected=true`,
  cancel: `&cancel_url=${window.location.origin}/b2cSteps`
}

// b2c new flow
export const plansLookupRedirectUrlsForFlow = {
  success: `?success_url=${window.location.origin}/individualGetPlan`,
  cancel: `&cancel_url=${window.location.origin}/individualGetPlan`
}

export const plansLookupRedirectUrlsOnManagePlan = {
  success: `?success_url=${window.location.origin}/user/managePlan?planSelected=true`,
  cancel: `&cancel_url=${window.location.origin}/user/managePlan`
}

export const plansLookupRedirectUrlsOnMeetingsPage = {
  success: `?success_url=${window.location.origin}/user/meetings?upgraded=true`,
  cancel: `&cancel_url=${window.location.origin}/user/meetings`
}

export const plansLookupRedirectUrlsOnMentorsPage = {
  success: `?success_url=${window.location.origin}/user/matchedMentors?upgraded=true`,
  cancel: `&cancel_url=${window.location.origin}/user/matchedMentors`
}

export const plansLookupRedirectUrlsOnMessagesPage = {
  success: `?success_url=${window.location.origin}/user/messages?upgraded=true`,
  cancel: `&cancel_url=${window.location.origin}/user/messages`
}

export const flowType = {
  matchMentor: "matchMentor",
  editEssay: "editEssay",
  explorePlan: "explorePlan",
  testPrep: "testPrep",
  matchedMentors: "user/matchedMentors",
  notSure: "notSure",
}

export const MeetingPlansRedirectUrls = {
  success: `${window.location.origin}/user/meetings`,
  cancel: `${window.location.origin}/user/meetings`
}

export const MentorsPlansRedirectUrls = {
  success: `${window.location.origin}/user/matchedMentors`,
  cancel: `${window.location.origin}/user/matchedMentors`
}

export const MessagesPlansRedirectUrls = {
  success: `${window.location.origin}/user/messages`,
  cancel: `${window.location.origin}/user/messages`
}

export const documentPlansRedirectUrls = {
  success: `${window.location.origin}/user/documents`,
  cancel: `${window.location.origin}/user/documents`
}

export const dashboardPlansRedirectUrls = {
  success: `${window.location.origin}/user/dashboard`,
  cancel: `${window.location.origin}/user/dashboard`
}

export const ManagePlansRedirectUrls = {
  success: `${window.location.origin}/user/planDashboard`,
  cancel: `${window.location.origin}/user/planDashboard`
}
export const testPrepRedirectUrls = {
  success: `${window.location.origin}/user/testPrep?isSuccess=true`,
  cancel: `${window.location.origin}/user/testPrep`
}

export const mentorPayout = {
  redirect: `?refresh_url=${window.location.origin}/mentorSteps&return_url=${window.location.origin}/mentorSteps?mentorRegistered=true`
}
export const mentorProfilePayout = {
  redirect: `?refresh_url=${window.location.origin}/profile&return_url=${window.location.origin}/profile`
}

export const meetingPlans = {
  PLANS_LOOK_UP: "&type=PLANS_LOOK_UP",
  MEETING_PLANS: "&type=MEETING_PLANS",
  ESSAY_PLANS: "&type=ESSAY_PLANS"
}

export const SpecificPlan = {
  is_meeting: "?is_meeting=true",
  is_document: "?is_document=true",
  meetingAndDocument: "?is_document=true&is_meeting=true"
}

export const listOfPlans = {
  COLLEGE_ELITE: "COLLEGE_ELITE",
  COLLEGE_CONFIRMED: "COLLEGE_CONFIRMED",
  APPLICATION_ACCELERATOR: "APPLICATION_ACCELERATOR",
  COLLEGE_CUROSITY: "COLLEGE_CUROSITY",
  FREE: "FREE" // temp due to BE changes
}
export const planNameToDisplay = {
  COLLEGE_ELITE: "College Elite",
  COLLEGE_CONFIRMED: "College Confirmed",
  APPLICATION_ACCELERATOR: "Application Accelerator",
  COLLEGE_CUROSITY: "College Curiosity",
}

export const createUserEndpoints = {
  SuperAdmin: "addSuperAdmin",
  B2BStudent: "addB2BStudent",
  SchoolAdmin: "addSchoolAdmin",
  B2CStudent: "addB2CStudent",
  addMentor: "addMentor"
}
// don't change the role because this role is used throughout the application
export const role = {
  mentor: "mentor",
  student: "student",
  admin: "admin",
  b2c_student: "b2c_student"
}

export const questionType = {
  MENTOR_SIMILAR_BACKGROUND: "MENTOR_WHOS_SIMILAR_BACKGROUND_TO_YOU",
  SCHOOL_INTEREST: "SCHOOLS_YOU_ARE_INTERESTED",
  LANGUAGE: "ENGLISH_IS_NOT_YOUR_FIRST_LANGUAGE",
  COLLEGE_CONTACT_HELP: "COLLEGE_CONTACT_HELP",
  FAVOURITE_SUBJECTS: "FAVOURITE_SUBJECTS_IN_SCHOOL",
  MAJOR_CATEGORIES: "MAJOR_CATEGORIES",
  AFTER_SCHOOL: 'LIKE_TO_DO_AFTER_SCHOOL'
}

export const role_name = {
  MENTOR: "Mentor",
  STUDENT: "Student",
  COLLEGE_ADMIN: "College Admin",
  SUPER_ADMIN: "SUPER_ADMIN"
}

export const ROLE_NAME = {
  STUDENT: "STUDENT",
  MENTOR: "MENTOR"
}
export const user_type = {
  B2B: "b2b_student",
  B2C: "b2c_student",
  MENTOR: "mentor",
  COLLEGE_ADMIN: "college_admin",
  SUPERADMIN: "super_admin"
}

export const MeetingType = {
  previous: "previous",
  upcoming: "upcoming",
  cancelled: "cancelled",
  rescheduled: "rescheduled",
  missed: "missed"
}

export const meetingStatus = {
  CANCELLED: "CANCELLED",
  SCHEDULED: "SCHEDULED",
  MISSED: "MISSED"
}

export const yes_no = {
  YES: "yes",
  NO: "no"
}

export function getUserId() {
  let userId = null;
  const idToken = localStorage.getItem("idToken");
  if (idToken) {
    const decoded = jwtDecode(idToken);
    if (decoded && decoded['custom:user_uuid']) {
      userId = decoded['custom:user_uuid'];
    }
  }
  return userId;
}

export const GPA = {
  unweighted_isNumber: "Unweighted GPA must be a number",
  unweighted_range: "Unweighted GPA must be between 0 and 4.00",
  weightted_isNumber: "Weighted GPA must be a number",
  weighted_range: "Weighted GPA must be between 0 and 6.00",
  radio_selected: "Please select a option",
  sat_score_number: "SAT score must be a number",
  sat_score_range: "SAT score must be between 400 and 1600",
  act_score_number: "ACT score must be a number",
  act_score_range: "ACT score must be between 1 and 36",
}

export const isEmpty = (checkValue) =>
  checkValue === null ||
  checkValue === "undefined" ||
  checkValue === "null" ||
  checkValue === undefined ||
  checkValue === "" ||
  checkValue.length === 0 ||
  checkValue === "false" ||
  Object.keys(checkValue).length === 0;


export const showdate = (providedDate) => {
  const date = new Date(providedDate);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true, // Use 12-hour clock with AM/PM
  };

  return date.toLocaleString('en-US', options);
}  

export const dateFormat = (providedDate) => {
  if (isEmpty(providedDate)) {
    return "";
  }
  const originalDate = new Date(providedDate);
  const formattedDate = originalDate.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return formattedDate;
}

export function validate(values) {
  let errors = {};
  if (!values.email) {
    errors.email = en.EMAIL_ERROR;
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = en.EMAIL_ADDRESS_ERROR;
  }
  if (!values.password) {
    errors.password = en.PASSWORD_REQUIRED;
  } else if (!values.confirmPassword) {
    errors.confirmPassword = en.PASSWORD_REQUIRED;
  } else if (values.password.length < 8) {
    errors.password = en.PASSWORD_CHARACTER_ERROR;
  } else if (!/\d/.test(values.password) || !/[!@#$%&?]/.test(values.password)) { //combined num and special char error msg as per requirement.
    errors.password = en.PASSWORD_NO_SPECIALCHAR_ERROR;
  // } else if (!/[!@#$%&?]/g.test(values.password)) {
  //   errors.password = en.PASSWORD_SPECIAL_CHARACTER_ERROR;
  } else if (!/[A-Z]/g.test(values.password)) {
    errors.password = en.PASSWORD_CAPITAL_ERROR;
  }
  return errors;
}

export function formatDate(date, joinFormate = "/") {
  if (!date) return null;

  const d = new Date(date); // convert string into date format for further date operations
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());
  const lastTwoDigits = year.slice(-2);

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [month, day, lastTwoDigits].join(joinFormate);
}

export function meetingCanceledOn(date, joinFormate = "/") {
  if (!date) return null;

  const d = new Date(date); // convert string into date format for further date operations
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [month, day, year].join(joinFormate);
}

export function addDueDate(createdDate, daysToAdd, isMentor) {

  const momentDate = moment(createdDate).tz(userTimeZone).add(daysToAdd, 'days');
  const formattedDate = isMentor ? momentDate.format('MM/DD/YY hh:mm A') : momentDate.format('MM/DD/YY');

   return formattedDate;
}

export const chipDesignValues = (savedValues) => {
  let originalArray = [];
  if (!isEmpty(savedValues)) { originalArray = savedValues.split(",") }
  const arrayOfObjects = originalArray.map((value, index) => {
    return { id: index + 1, name: value };
  });
  return arrayOfObjects;
}

export const getInitial = (value, initialName = false) => {
  // mentor name format ex. John D
  const nameParts = value?.split(' ');
  const firstName = nameParts[0];
  const LastName = nameParts[1];
  if(initialName){
    return initialName ? firstName?.charAt(0) + "" + LastName?.charAt(0) : null;
  }else {
  return LastName ? firstName + " " + LastName?.charAt(0) : firstName;
  }
};

export const getMoreData = (data, dataLength) => {
  if (data?.length > dataLength) {
    return `${data?.slice(0, dataLength)}...`
  }
  return data;
}

function isValidURL(url) {
  const urlPattern = /^(https?:\/\/)?([\w-]+\.)*([\w-]+\.([a-zA-Z]{2,}|\d{1,3}))(\/[\w-./?%&=]*)?$/;
  return urlPattern.test(url) || urlPattern.test("http://" + url);
}

export const validateFormField = (fieldName, value, isB2C, isMentor, radioValue) => {
  if (fieldName === 'document_title') {
    return isEmpty(value) ? 'Document name is required' : '';
  }
  if (fieldName === 'doc_link') {
    if (!value) return 'Document link is required';
    if (!isValidURL(value)) return 'Invalid document link';
    return '';
  }
  if (fieldName === 'doc_type') {
    return isEmpty(value) ? 'Doc type is required' : '';
  }
  if (fieldName === 'due_date' && (isB2C || isMentor)) {
    return isEmpty(value) ? 'Due date is required' : '';
  }
  // if (fieldName === 'essay_prompt') {
  //   return isEmpty(value) ? 'Essay prompt is required' 
  //   : value?.length > 250 ? 'Essay prompt length should not exceed 250 characters' : '';
  // }
  if (fieldName === 'school_id' && radioValue === "yes") {
    return isEmpty(value) ? 'School name is required' : '';
  }
  // if (fieldName === 'mentor_id' && isB2C) {
  //   return value === 0 ? 'Mentor name is required' : '';
  // }
  if (fieldName === 'concerns') {
    return !isEmpty(value) && value?.length > 500 ? 'Concerns length should not exceed 500 characters' : '';
  }
  if (fieldName === 'rejection_reason') {
    return isEmpty(value) ? 'Rejection reason is required' : '';
  }
  if (fieldName === 'acknowledge_flag') {
    return value === false ? 'Acknowledge policy is required' : '';
  }
  return '';
};

//add result popup on submit validations
export const addResultValidation = (fields, setFinalFormErrors) => {

  return fields.every((field) => {
      const { school_id, result_id } = field;

      // If there are multiple fields and none of them has both fields filled
      if (fields.length > 1 && fields.every((field) => !field.school_id && !field.result_id)) {
        setFinalFormErrors({ isError: true, msg: en.SUBMIT_RESULT_ERROR });
          return false;
      }

      // Both can be empty, but one must not be empty if the other is filled.
      if ((school_id && !result_id) || (!school_id && result_id)) {
        setFinalFormErrors({ isError: true, msg: en.SUBMIT_RESULT_ERROR });
          return false;
      }

      // If there is only 1 object and both fields are empty
      if ((fields.length === 1 || fields.length === 0) && !school_id && !result_id) {
        setFinalFormErrors({ isError: true, msg: en.SUBMIT_RESULT_ERROR });
          return false;
      }

      return true;
  });
};

//function to check is duplicates school results are getting added and creating dublicate ids of school
export const checkForDuplicateSchools = (fields, setSchoolFormErrors) => {
  const uniqueSchools = new Set();
  const duplicateSchools = [];

  // Check for duplicate schools
  fields?.forEach((field) => {
    const { school_id } = field;

    // Skip if no school_id is provided
    if (school_id) {
      if (uniqueSchools?.has(school_id)) {
        // Add the duplicate to the list
        duplicateSchools?.push(school_id);
      } else {
        uniqueSchools?.add(school_id);
      }
    }
  });

  // If duplicates are found, set the error messages and add them to sameSchoolIds
  if (duplicateSchools?.length > 0) {
    setSchoolFormErrors(duplicateSchools); 

    // Return false if duplicates are found
    return false;
  }
  // Return true if no duplicates are found
  return true;
};

export const addCollegeValidation = (fields, setFinalFormErrors) => {
  // Return true if all fields have valid school_id and result_id
  const isValid = !fields?.some(field => !field?.school_id || !field?.result_id);
  if (!isValid) {
    setFinalFormErrors({ isError: true, msg: en.ADD_MORE_CLG_ERROR });
    return false;
  }
  return true;
};

// Calendly date format
export function CalendlyDateFormat(fromDateTime, toDateTime) {
  if (isEmpty(fromDateTime) || isEmpty(toDateTime)) {
    return { "startDate": "", "startTime": "", "endTime": "" };
  }
  const fromDate = new Date(fromDateTime);
  const toDate = new Date(toDateTime);
  const formatTime = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  };

  const startDate = fromDate.toLocaleDateString('en-US');
  const startTime = formatTime(fromDate);
  const endTime = formatTime(toDate);
  return { "startDate": startDate, "startTime": startTime, "endTime": endTime };
}

//to check if the current time occurs in meeting scheduled time so student can report that mentor has not joined the meeting yet
export function isCurrentTimeWithinRange(startDate, startTime, endTime) {
  // Parse the start and end datetime strings
  const startDateTime = new Date(`${startDate} ${startTime}`);
  const endDateTime = new Date(`${startDate} ${endTime}`);

  // Get the current local time
  const currentTime = new Date();

  // Check if the current time falls within the range
  return currentTime >= startDateTime && currentTime <= endDateTime;
}

export function isMeetingFromTimePassed(dateTime) {
  const providedDate = new Date(dateTime); // Convert input string to a Date object
  const currentDate = new Date(); // Get the current local date and time
  
  return providedDate.getTime() < currentDate.getTime(); // Compare timestamps
}

export function calculateTimeDifference(startTime, endTime) {
  const startDate = new Date("1970-01-01 " + startTime);
  const endDate = new Date("1970-01-01 " + endTime);
  const timeDifference = endDate - startDate;
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  return { hours, minutes };
}

export function formatTimestamp(timestamp) {
  const date = new Date(timestamp);
  const currentDate = new Date();
  const yesterdayDate = new Date(currentDate);
  yesterdayDate.setDate(currentDate.getDate() - 1);

  if (date.toDateString() === yesterdayDate.toDateString()) {
    return 'Yesterday';
  }

  if (date.toDateString() === currentDate.toDateString()) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
  }

  const oneDayInMillis = 24 * 60 * 60 * 1000;
  if (currentDate - date > oneDayInMillis) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  }

  const hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  return `${formattedDate} ${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
}


export function parseQueryString(queryString) {
  queryString = queryString?.slice(1);
  var keyValuePairs = queryString?.split('&');
  var queryObject = {};
  keyValuePairs?.forEach(function (keyValuePair) {
    var pair = keyValuePair?.split('=');
    queryObject[pair[0]] = pair[1];
  });
  return queryObject;
}

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const findAndAppendDuplicates = (preferences) => {

  const seenSubCategoryIds = new Set();
  const seenOptionIds = new Set();
  const seenQuestionIds = new Set();
  const modifiedPreferences = [];

  preferences?.forEach((preference) => {
    const modifiedPreference = { ...preference };

    if (seenSubCategoryIds.has(modifiedPreference?.sub_category_id)) {
      modifiedPreference.sub_category_id += "_duplicate";
    } else {
      seenSubCategoryIds.add(modifiedPreference?.sub_category_id);
    }

    if (modifiedPreference.option_id) {
      if (seenOptionIds.has(modifiedPreference.option_id)) {
        modifiedPreference.option_id += "_duplicate";
      } else {
        seenOptionIds.add(modifiedPreference.option_id);
      }
    }

    if (seenQuestionIds.has(modifiedPreference.question_id)) {
      modifiedPreference.question_id += "_duplicate";
    } else {
      seenQuestionIds.add(modifiedPreference.question_id);
    }

    modifiedPreferences.push(modifiedPreference);
  });

  if (isEmpty(modifiedPreferences)) {
    return preferences;
  } else {
    return modifiedPreferences;
  }

}

export function formatDueDate(date, joinFormate = "-") {
  if (!date) return null;

  const d = new Date(date); // convert string into date format for further date operations
  let month = String(d.getMonth() + 1);
  let day = String(d.getDate());
  const year = String(d.getFullYear());
  // const lastTwoDigits = year.slice(-2);

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join(joinFormate);
}

export const checkList = {
  due_date: "Please select a Due Date.",
  college_name: "Please select a College Name.",
  task_name: "Please select a Task Name.",
  premade_checklist: "Please select a premade checklist.",
  other_task_name: "Please enter a Task.",
  comment: "Please add comment",
  // duplicate_task_name: "You can not select duplicate task name."
}

export function getNextThreeDatesInTimeZone() {
  const today = new Date();
  const timeZoneOffset = today.getTimezoneOffset() / 60; // Convert minutes to hours

  // Today
  const startDate = new Date(today);
  startDate.setHours(today.getHours() + timeZoneOffset); // Adjust for time zone
  const startDateString = startDate.toISOString().split('T')[0];

  // Tomorrow
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  tomorrow.setHours(today.getHours() + timeZoneOffset);
  const middleDateString = tomorrow.toISOString().split('T')[0];

  // Day after tomorrow
  const dayAfterTomorrow = new Date(today);
  dayAfterTomorrow.setDate(today.getDate() + 2);
  dayAfterTomorrow.setHours(today.getHours() + timeZoneOffset);
  const endDateString = dayAfterTomorrow.toISOString().split('T')[0];

  return { startDate: startDateString, middleDate: middleDateString, endDate: endDateString };
}


export const getdayFromDate = (providedDate) => {
  if(!isEmpty(providedDate)){
    const date = new Date(providedDate);
    return date.toLocaleDateString("en-US", { weekday: 'long' });
  }
  return "";
}

// for add credits in doc type lists
// export const getDocTypeCredits = (lookupkeys) => {
//   const checkTypes = [en.ACTIVITIES_SECTION_TWO_ESSAY_CREDIT, en.ESSAY_UNDER_350_TWO_ESSAY_CREDIT, en.EXTRA_INFORMATION_SECTION_TWO_ESSAY_CREDIT, en.RESUME_TWO_ESSAY_CREDIT]?.includes(lookupkeys);
//   const checkCreditTypes = [en.ADMISSION_REP_EMAIL_THREE_ESSAY_CREDIT, en.COVER_LETTER_THREE_ESSAY_CREDIT, en.ESSAY_350_PLUS_WORDS_THREE_ESSAY_CREDIT, en.LETTER_OF_CONTINUED_THREE_ESSAY_CREDIT, en.FOUR_UC_PIQS_THREE_ESSAY_CREDIT]?.includes(lookupkeys);
//   const UC_PIQ_8Credits = [en.FOUR_UC_PIQS_EIGHT_ESSAY_CREDIT]?.includes(lookupkeys);
//   const clgApp10Credits = [en.COLLEGE_APP_TEN_ESSAY_CREDITS]?.includes(lookupkeys);
//   const title  = checkTypes ? '- 2 Credits' : checkCreditTypes ? '- 3 Credits' : UC_PIQ_8Credits ? '- 8 Credits' : clgApp10Credits ? '- 10 Credits' : "";
//   return title;
// }

export const getDocTypeCredits = (lookupkeys) => {
  const twoCreditTypes = [
    en.ACTIVITIES_SECTION_TWO_ESSAY_CREDIT,
    en.ESSAY_UNDER_350_TWO_ESSAY_CREDIT,
    en.EXTRA_INFORMATION_SECTION_TWO_ESSAY_CREDIT,
    en.RESUME_TWO_ESSAY_CREDIT
  ];

  const threeCreditTypes = [
    en.ADMISSION_REP_EMAIL_THREE_ESSAY_CREDIT,
    en.COVER_LETTER_THREE_ESSAY_CREDIT,
    en.ESSAY_350_PLUS_WORDS_THREE_ESSAY_CREDIT,
    en.LETTER_OF_CONTINUED_THREE_ESSAY_CREDIT
  ];

  const eightCreditTypes = [
    en.FOUR_UC_PIQS_EIGHT_ESSAY_CREDIT
  ];

  const tenCreditTypes = [
    en.COLLEGE_APP_TEN_ESSAY_CREDIT
  ];

  if (twoCreditTypes.includes(lookupkeys)) return '- 2 Credits';
  if (threeCreditTypes.includes(lookupkeys)) return '- 3 Credits';
  if (eightCreditTypes.includes(lookupkeys)) return '- 8 Credits';
  if (tenCreditTypes.includes(lookupkeys)) return '- 10 Credits';

  return ""; // Default case if no match is found
};

// check Duplicate value in Chip
export const checkDuplicateChipValue = (value, selectedValue, setSelectedValue) => {
  const newIds = value?.map((newVal) => newVal?.id);
  // Filtering out ids that are not already present in selectedValue
  const uniqueNewValueIds = newIds?.filter(id => !selectedValue.some(lang => lang.id === id));
  // Filtering out the languages with unique ids
  const uniqueValues = value?.filter(lang => uniqueNewValueIds?.includes(lang.id));
  setSelectedValue([...selectedValue, ...uniqueValues]);
}

export const mentorRequestApproval = {
  APPROVED_BY_ADMIN: 'APPROVED_BY_ADMIN',
  REJECTED_BY_ADMIN: 'REJECTED_BY_ADMIN',
  PENDING_APPROVAL_FROM_ADMIN: 'PENDING_APPROVAL_FROM_ADMIN'
}

export const displayRoleForAdminNotes = (role) => ({
  SUPER_ADMIN: "Super Admin",
  TEACHER: "Teacher",
  COUNSELOR: "Counselor",
  PRINCIPAL: "Principal",
  "ASSISTANT SUPERINTENDENT": "Assistant Superintendent",
  SUPERINTENDENT: "Superintendent",
  OTHER: "Other",
  COLLEGE_ADMIN: "College Admin",
}[role]);

export const userTimeZone = 'America/New_York'

export const docFormDueDateId = {
  is24Hr: 'c9b2351b-ace8-48af-a883-ecdb9a5237da',
  is72Hr: '034d19a7-c38f-4456-b32c-30b450a62aaf'
}

export const DocListHeadCells = {
  b2b_student: [
    { id: "document_title", disablePadding: false, label: "Document Name" },
    { id: "mentor_name", disablePadding: false, label: "Mentor Name" },
    { id: "created_at", disablePadding: false, label: "Submitted On" },
    { id: "due_date", disablePadding: false, label: "Return Date" },
    { id: "status", disablePadding: false, label: "Status" },
  ],
  b2c_student: [
    { id: "document_title", disablePadding: false, label: "Document Name" },
    { id: "mentor_name", disablePadding: false, label: "Mentor Name" },
    { id: "created_at", disablePadding: false, label: "Submitted On" },
    { id: "due_date", disablePadding: false, label: "Return Date" },
    { id: "status", disablePadding: false, label: "Status" },
  ],
  super_admin: [
    { id: "document_title", disablePadding: false, label: "Document Name" },
    { id: "student_name", disablePadding: false, label: "Student Name" },
    { id: "mentor_name", disablePadding: false, label: "Mentor Name" },
    { id: "created_at", disablePadding: false, label: "Submitted On" },
    { id: "calculated_due_date", disablePadding: false, label: "Due Date" },
    { id: "returned_on", disablePadding: false, label: "Returned On" },
    { id: "status", disablePadding: false, label: "Status" },
  ],
  mentor: [
    { id: "document_title", disablePadding: false, label: "Document Name" },
    { id: "student_name", disablePadding: false, label: "Student Name" },
    { id: "created_at", disablePadding: false, label: "Submitted On" },
    { id: "due_date", disablePadding: false, label: "Due Date" },
    { id: "status", disablePadding: false, label: "Status" },
  ],
};

export const resultTableHeadCells = [{ id: "college_name", disablePadding: false, label: "College" },
{ id: "status_name", disablePadding: false, label: "Status" },
{ id: "is_favourite", disablePadding: false, label: "Favorite School" }
];

//Superadmin login all meetings table status column labels
export const superadminAllMeetingsStatus = {
  COMPLETED: 'Complete',
  CANCELLED: 'Canceled',
  RESCHEDULED: 'Rescheduled',
  SCHEDULED: 'Upcoming',
  PENDING: 'Pending',
  MISSED: 'Missed',
  NOT_SCHEDULED: 'Not Scheduled'
};

export const modifiedGradeForSA = (gradeName) => {
  const gradeMapping = {
    "College transfer student": "TS",
    "Middle School": "MS",
    "11th": "11",
    "12th": "12",
    "10th": "10",
    "9th": "9",
  };
  return gradeMapping[gradeName] || gradeName; // Return mapped value or original name
};

export const getIconTitle = (title, isMentorOrSA, studId) => {
  if ((isMentorOrSA == true && !studId) && title === "Application Progress") {
    return "Essay Guides";
  }
  if ((isMentorOrSA == true && !studId) && title === "College List") {
    return "Admissions Tools";
  }
  return title;
};

// Only setting these 6 preLoginAllowedRoutes as per client requirement.  
//So that when logged out user hits below routes will land on sign page and then the requested route.
export const preLoginAllowedRoutes = [
  "/user/managePlan",
  "/user/newDocument",
  "/user/meetings",
  "/user/matchedMentors",
  "/user/materials",
  "/user/dashboard",
  "/user/dashboard?addResult=true",
  "/user/messages",
  "/user/testPrep"
];

// check Duplicate course value in Chip
export const checkDuplicateCourseChipValue = (value, selectedValue, setSelectedValue) => {
  const newIds = value?.map((newVal) => newVal?.uuid);
  // Filtering out uuids that are not already present in selectedValue
  const uniqueNewValueIds = newIds?.filter(uuid => !selectedValue.some(lang => lang.uuid === uuid));
  // Filtering out the course with unique uuids
  const uniqueValues = value?.filter(lang => uniqueNewValueIds?.includes(lang.uuid));
  setSelectedValue([...selectedValue, ...uniqueValues]);
}

export const packageFlowRedirectURLs = {
  success_url: `${window.location.origin}/user/matchedMentors`,
  cancel_url: `${window.location.origin}/user/matchedMentors`
}